import React from 'react'
import { AgreementPrevVersionListItemProps } from './AgreementPrevVersionListItem.types'
import styles from './AgreementPrevVersionListItem.module.scss'
import cl from 'classnames'
import { HorizontalLine, Text1 } from 'components/shared'
import moment from 'moment'

const AgreementPrevVersionListItemComponent = (props: AgreementPrevVersionListItemProps) => {
  const {
    className,
    style,
    agreementName,
    createdDate,
    updatedBy,
    versionNumber
  } = props

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <Text1 className={styles.versionNumber}>
        Version {versionNumber < 10 && '0'}{versionNumber}
      </Text1>
      <Text1 className={styles.agreementName}>
        {agreementName}
      </Text1>

      <div className={styles.infoContainer}>
        <Text1
          overflowEllipsis
          title={moment(createdDate).format('DD/MM/YYYY')}
        >
          {moment(createdDate).fromNow()}
        </Text1>
        <Text1 overflowEllipsis>By {updatedBy}</Text1>
      </div>

      <HorizontalLine />
    </div>
  )
}

const AgreementPrevVersionListItem = AgreementPrevVersionListItemComponent
export { AgreementPrevVersionListItem }
